import { Provider } from '@angular/core';
import { provideComponentStore } from '@ngrx/component-store';
import { CourseStore } from '../store';
import { SchoolLocationService } from '../services';

/**
 * Provides the necessary services and stores for the correct behaviour of the
 * course selection components.
 *
 * Due to CourseStore lives at component level and SchoolLocationService uses that store,
 * we need to provide both at the same time in the component providers.
 *
 * Being provided both at the same time we make sure we have the same instance of CourseStore in both the
 * component and on SchoolLocationService.
 */
export const getCourseSelectionProviders = (): Provider[] => {
  return [provideComponentStore(CourseStore), SchoolLocationService];
};
